<template>
  <div id="user-setting">
    <div class="content">
        <a-tabs defaultActiveKey="2" tabPosition="left">
            <a-tab-pane tab="用户管理" disabled key="1"></a-tab-pane>
            <a-tab-pane tab="邀请用户" key="2">
                <a-form :form="form" @submit="handleSubmit">
                <a-form-item label="手机号" :label-col="{ span: 5 }" :wrapper-col="{ span: 5 }">
                    <a-input v-decorator="['phone', { rules: [{ required: true, message: '请输入手机号!' }] }]" />
                </a-form-item>
                <a-form-item label="姓名" :label-col="{ span: 5 }" :wrapper-col="{ span: 5 }">
                    <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入姓名!' }] }]" />
                </a-form-item>
                <a-form-item label="单位" :label-col="{ span: 5 }" :wrapper-col="{ span: 5 }">
                    <a-input
                    v-decorator="['department', { rules: [{ required: true, message: '请输入单位!' }] }]"
                    />
                </a-form-item>
                <a-form-item label="备注" :label-col="{ span: 5 }" :wrapper-col="{ span: 5 }">
                    <a-input v-decorator="['supplement']" />
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
                    <a-button type="primary" html-type="submit">提交</a-button>
                </a-form-item>
                </a-form>
            </a-tab-pane>
        </a-tabs>
    </div>
  </div>
</template>

<script>
import UrlApi from "@/utils/UrlApi.js";
export default {
  name: "UserSetting",
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this, { name: "coordinated" })
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      const that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          const userId = this.$store.getters.getUserId;
          let param = `inviterUserId=${userId}&phone=${values.phone}&name=${values.name}&department=${values.department}&supplement=${values.supplement||''}`;
          // console.log(param)
          this.$http.post(UrlApi.inviteUser, param,{
              headers:{
                  "Authorization": this.$store.getters.getToken,
                  "content-type": "application/x-www-form-urlencoded"
              }
          }).then((res)=>{
              if(res.data.success){
                this.$message.success(res.data.message);
                that.form.resetFields();
              } else {
                this.$message.error(res.data.message);
              }
          })
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
#user-setting {
  width: 100%;
  margin: 0 auto;
  min-height: calc(100vh - 145px);
  height: calc(100vh - 145px);
  padding: 30px;
  .content {
    height: 100%;
    padding-top: 40px;
    background-color: #ffffff;
  }
}
</style>